import "./RemoveNoteGroup.scss";

function RemoveNoteGroup({
  cancelRemoveNoteGroup,
  removeNoteGroup,
  noteGroupName,
}) {
  return (
    <div className="remove-notegroup-content">
      <div className="modal-title">
        <div>Remove Notegroup</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete "{noteGroupName}"?</p>
        <p className="warning-text">This will not delete the notes inside.</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveNoteGroup}>
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeNoteGroup}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default RemoveNoteGroup;
